<div class="mx-auto row template3 menu-block1 app-second-level-menu col-12 p-md-0" *ngIf="!isHamburger">
      <!--TO SHOW MENU'S FOR FBO's and others - Desktop-->
    <nav id="primary_nav_wrap" class="w-100 container px-0" *ngIf="!showFPCMenu">
        <ul class="row w-100 ">
            <ng-container *hasPrivilege="['Dashboard']">
                <li class="col text-center">
                    <a href="javascript:void(0)" tabindex="0"
                        attr.aria-label="{{'header.Dashboard'|translate|translateKey}}"
                        (keyup.enter)="navigateToAccount()" (click)="navigateToAccount()">
                        <img imgSrc="/images/dashboard.png" alt="my account">
                        <span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.Dashboard'|translate|translateKey}}</span>
                    </a>
                </li>
            </ng-container>
            <ng-container *hasPrivilege="['ReportsLink']">
                <li id="sub-menu-style" class="col text-center d-md-none" tabindex="0"
                    attr.aria-label="{{'header.Reports'|translate|translateKey}}"
                    (click)="navigateToReports('/basic-reports-page');">
                    <a href="javascript:void(0)">
                        <img imgSrc="/images/my business.png" alt="Reports"><span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.Reports'|translate|translateKey}}</span></a>
                </li>

                <!-- Desktop My Business(Reports) secondlevel menu START-->
                <li id="sub-menu-style" class="col text-center d-none d-md-inline-block" tabindex="0"
                    attr.aria-label="{{'header.Reports'|translate|translateKey}}" (keyup.enter)="showSubMenu();">
                    <a href="javascript:void(0)" (click)="navigateToReports('/basic-reports-page')">
                        <img imgSrc="/images/my business.png" alt="Reports"><span
                            class="d-none d-sm-inline-block pl-2 menu-title">{{'header.Reports'|translate|translateKey}}</span></a>
                    <!-- <ul role="menuitem" style="z-index:1000;" id="business-menu-list" class="width-md-100 app-menu-list" *ngIf="reports && reports.childs">
                    <li class="text-left w-100 subMenu" tabindex="0" attr.aria-label="{{submenu.name}}" (mouseover)="showSubsubMenu(i);" (mouseleave)="showSubsubMenu(-1);" (focus)="showSubsubMenu(i);" *ngFor="let submenu of reports.childs | sort:'sortOrder' ;let i= index">
                        <a>{{'menu.'+submenu.name |translate|translateKey}}</a>
                        <ul [class.d-block]="subMenuselected===i" *ngIf="submenu && submenu.childs">
                            <li class="subsubmenu" (keyup.enter)="navigateToReports(subsubmenu.url)" (click)="navigateToReports(subsubmenu.url)" *ngFor="let subsubmenu of submenu.childs | sort:'sortOrder'">
                                <a tabindex="0" attr.aria-label="{{subsubmenu.name}}">{{'menu.'+subsubmenu.name |translate|translateKey }}</a>
                            </li>
                        </ul>
                    </li>
                </ul> -->
                </li>
            </ng-container>
            <ng-container *hasPrivilege="['TrainingPage']">
                <!-- Desktop My Business(Reports) secondlevel menu END-->
                <li id="sub-menu-style" class="col text-center" tabindex="0"
                    attr.aria-label="{{'header.Training'|translate|translateKey}}" (click)="openTrainingSession()">
                    <a href="javascript:void(0)">
                        <img imgSrc="/images/training.png" alt="training"><span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.Training'|translate|translateKey}}</span></a>
                </li>
            </ng-container>
            <!-- Desktop Training secondlevel menu START-->
            <!-- <li id="sub-menu-style" class="col text-center d-none d-md-inline-block" tabindex="0" attr.aria-label="{{'header.Training'|translate|translateKey}}">
                <a href="javascript:void(0)">
                    <img imgSrc="/images/training.png" alt="training"><span class="d-none d-md-inline-block pl-2 menu-title">{{'header.Training'|translate|translateKey}}</span></a>
                <ul role="menuitem" style="z-index:1000;" id="business-menu-list" class="app-menu-list">
                    <li class="text-left w-140 subMenu" tabindex="0" (click)="navigateToFAQ(routePath.FBOFAQ)" attr.aria-label="training">
                        <a tabindex="0" attr.aria-label="{{'megamenu.FAQ'|translate|translateKey}}">{{'megamenu.FAQ' |translate|translateKey}}</a>
                    </li>
                </ul>
            </li> -->
            <!-- Desktop Tools secondlevel menu END-->
            <ng-container *hasPrivilege="['ToolsPage']">
                <li class="col text-center" (click)="navigateToTools(routePath.TOOLS)">
                    <a tabindex="0" href="javascript:void(0)">
                        <img imgSrc="/images/tools.png" alt="tools">
                        <span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.Tools'|translate|translateKey}}</span>
                    </a>
                </li>
            </ng-container>
            <ng-container *hasPrivilege="['flp360_menu_link']">
                <li class="col text-center" (click)="navigateToFLP360()">
                    <a href="javascript:void(0)">
                        <img imgSrc="/images/flp360.svg" alt="training">
                        <span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.FLP360'|translate|translateKey}}</span>
                    </a>
                </li>
            </ng-container>
            <ng-container *hasPrivilege="['RecognitionPage']">
                <li class="col text-center" (click)="openRecognitionLink()">
                    <a href="javascript:void(0)" tabindex="0"
                        attr.aria-label="{{'header.Recognition'|translate|translateKey}}">
                        <img imgSrc="/images/recognition.png" alt="recognition">
                        <span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.Recognition'|translate|translateKey}}</span>
                    </a>
                </li>
            </ng-container>
            <!-- <li class="col text-center">
                <a href="javascript:void(0)" tabindex="0" attr.aria-label="{{'header.Support'|translate|translateKey}}">
                    <img imgSrc="/images/support.png" alt="support">
                    <span class="d-none d-md-inline-block pl-2 menu-title">{{'header.Support'|translate|translateKey}}</span>
                </a>
            </li> -->
        </ul>
    </nav>
     <!--TO SHOW MENU'S FOR FPC Alone - Desktop-->
     <nav id="primary_nav_wrap" class="w-100 container px-0" *ngIf="showFPCMenu">
        <ul class="row w-100">
            <ng-container *hasPrivilege="['ReportsLink']">
                <li id="sub-menu-style" class="col text-center" tabindex="0"
                    attr.aria-label="{{'header.Reports'|translate|translateKey}}"
                    (click)="navigateToOrderReports('/reports/myorder');">
                    <a href="javascript:void(0)">
                        <img imgSrc="/images/my business.png" alt="Reports"><span
                            class="d-none d-md-inline-block pl-2 menu-title">{{'header.Reports'|translate|translateKey}}</span></a>
                </li>
            </ng-container>
        </ul>
    </nav>
</div>
<!-- Only for mobile hamburger menu -->
<div class="template3 app-second-level-menu" *ngIf="isHamburger">
    <nav>
        <ul class="list-unstyled fbo-portal__menu">
            <li class="" (click)="menuItemClicked(menu)" *ngFor="let menu of appMenus">
                <a tabindex="0">
                    <span class="menu-title">{{'header.'+menu.name|translate|translateKey}}</span>
                    <!-- <img class="float-right" imgSrc="/images/my account.png" alt="dashboard"> -->
                    <span class="fa fa-chevron-right float-right" *ngIf="menu.childs && menu.childs.length > 0"></span>
                </a>
            </li>
        </ul>
    </nav>
    <!-- Push Menu Start -->
    <div app-submenu [level]="level" [menuItems]="childMenus" [menuName]="parentMenuName" (backClicked)="goBack()"
        (openChildPushMenu)="openChildPushMenu($event)" (menuItemClicked)="menuItemClicked($event)"></div>
    <!-- Push Menu End -->
</div>